import { render, staticRenderFns } from "./BLItemEditN.vue?vue&type=template&id=5efa9015&"
import script from "./BLItemEditN.vue?vue&type=script&lang=js&"
export * from "./BLItemEditN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports